import { render } from "./PartnerDiscount.vue?vue&type=template&id=13cdff66"
import script from "./PartnerDiscount.vue?vue&type=script&lang=js"
export * from "./PartnerDiscount.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__